import { render } from "./HistoricBoxShow.vue?vue&type=template&id=726c7b2e&scoped=true"
import script from "./HistoricBoxShow.vue?vue&type=script&lang=js"
export * from "./HistoricBoxShow.vue?vue&type=script&lang=js"

import "./HistoricBoxShow.vue?vue&type=style&index=0&id=726c7b2e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-726c7b2e"]])

export default __exports__